// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 收藏/取消收藏产业链 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /chain/favorite */
export async function chainFavoriteUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.chainFavoriteUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/chain/favorite', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取产业链树状信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /chain/info */
export async function chainInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.chainInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultChainInfoResp>('/chain/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取产业链列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /chain/list */
export async function chainListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListChainDetailResp>('/chain/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取用户产业链列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /chain/list-by-user */
export async function chainListByUserUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListChainDetailResp>('/chain/list-by-user', {
    method: 'GET',
    ...(options || {}),
  });
}
